
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/LeanProjectTextArea/LeanProjectTextArea.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./LeanProjectTextArea.html');
        
        var script = require('./LeanProjectTextArea.ts').default;
        module.exports = require('./LeanProjectTextArea.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    